import { Component } from '@verndale/core';
import { getRandomColor } from '../helpers';

class Footer extends Component {
  constructor(el: HTMLElement) {
    super(el);

    this.generateRandomColor();
    this.setBackground();
  }

  setupDefaults() {
    this.dom = {
      main: document.querySelector<HTMLElement>('main')
    };
  }

  generateRandomColor() {
    const randomColor = getRandomColor();
    this.el.classList.add(`footer--${randomColor.name}`);
    (this.dom.main as HTMLElement).classList.add(`main--${randomColor.name}`);
  }

  setBackground() {
    const main = this.dom.main as HTMLDivElement;

    if (
      main &&
      main.lastElementChild?.classList.contains('dark-background-module')
    ) {
      this.el.classList.add('footer--dark');
    }
  }
}

export default Footer;
